/*global $, document, window, setTimeout, alert, typeof, FG, location, jintervals*/
(function () {
    "use strict";

    /**
     * FrongGate Cart timer class
     * @since 7/22/2013
     */
    FG.CartTimer = {

        /**
         * Database object
         * @var {FG.DB}
         */
        db: new FG.DB(),

        /**
         * Is this timer active
         * @var {bool}
         */
        isActive: null,

        /**
         * When should the timer be synced up with the values in local store
         * @var {number}
         */
        syncInterval: 30,

        /**
         * Expiry for when this cart should expire
         * @var {number} UNIX timestamp
         */
        cartExpiry: undefined,

        /**
         * The total number of seconds remaining for this timer
         * @var {number}
         */
        totalSeconds: undefined,

        /**
         * Is the cart timer paused?
         * @var {bool}
         */
        timerPaused: false,

        /**
         * Initialize this timer
         * @return this
         */
        init: function () {

            //Did someone pause the timer?
            if (this.timerPaused == true) {
                return this;
            }

            this.db = new FG.DB();

            var cartActive = this.db.get('cartActive'),
                cartExpiry = null;

            if (cartActive !== undefined && cartActive > 0) {

                cartExpiry = this.db.get('cartExpiry');
                $('.timer').show();

                if (typeof cartExpiry !== 'undefined') {

                    this.cartExpiry = cartExpiry;

                    this.activateNavBar();

                    this.startTimer();

                } else {

                    $('.timer').hide();
                }
            }

            return this;
        },

        /**
         * Activate the nav bar in the DOM
         * @return this
         */
        activateNavBar: function () {

            $('#cart').addClass('active').attr('data-toggle', '');

            return this;
        },

        /**
         * Start the timer
         * @return this
         */
        startTimer: function () {

            $('.timer').show();

            this.countdownTimer(this.calculateSecondsRemaining());

	    $(document).trigger('startTimer');

            return this;
        },

        /**
         * Run the countdown timer with delete cart function when time runs out
         * @param {number}  secsRemaining   number of seconds remaining
         */
        countdownTimer: function (secsRemaining) {

            var self = this,
                url = null;

            //If the time is up and the timer is not paused
            if (this.timerPaused == false && secsRemaining <= 0) {
                $('.timer').hide();

		$('.timer-summary').html('');

                $('#cart').removeClass('active');

                url = $("#labelRoot").val() + '/cart/delete_cart';

                $.post(
                    url,
                    {
                        dev: 'null',
                        keepSession : true,
                        csrf_token: FG.Utils.getToken()
                    },
                    function (FGResponse) {

                        self.deleteTimer();
                        $('#modal-cart-expired').modal('show');

                        //Make the cart inactive
                        var db = new FG.DB();
                        db.remove('cartActive');
                
                        //Delete the cart timer
                        FG.CartTimer.deleteTimer();

                        // Remove cart tracking data
                        FG.tradableBits().removeCartData();

                        FG.Cart.init();

                        FG.CartTimer.init();

                    },
                    "json"
                );

            } else {
                setTimeout(function () {
                    self.countdownTimer(self.calculateSecondsRemaining());
                }, 1000);
            }

            $('.timer span.time').text(jintervals(secsRemaining, '{MM}:{ss}'));
	    
	    if(secsRemaining%60 == 0 && secsRemaining > 0){
		$('.timer-summary').text('Your cart will expire in ' + jintervals(secsRemaining, '{Minutes?}'));
	    }else if(secsRemaining <= 180 && secsRemaining%30 == 0 && secsRemaining > 0){
		 $('.timer-summary').text('Your cart will expire in ' + jintervals(secsRemaining, '{Minutes? and} {seconds?}'));
	    }

            secsRemaining--;
        },

        /**
         * Calcualte the number of seconds remaining till this timer expires
         * @return {number}
         */
        calculateSecondsRemaining: function () {

            /**
             * Current user UNIX timestamp (seconds since epoch)
             * @type {number}
             */
            var currentTimestamp = FG.Base.getCurrentTimestamp(),
                secondsRemaining = (currentTimestamp < this.cartExpiry) ? (this.cartExpiry - currentTimestamp) : 0;

            return secondsRemaining;
        },

        /**
         * Delete the cart timer completely from local store
         * @return this
         */
        deleteTimer: function () {

            this.db.set('totalCount', 0);

            this.db.set('cartExpiry', 0);

            this.db.set('cartActive', 0);

            this.db.set('totalCount', 0);

            localStorage.removeItem('cxid');
            
            return this;

        },

        /**
         * Pause the timer
         * @return this
         */
        pauseTimer: function () {

            this.timerPaused = true;

            this.init();

            $('.timer').hide();

            return this;
        },

        /**
         * Unpause timer
         * @return this
         */
        unpauseTimer: function () {

            this.timerPaused = false;

            this.init();

            return this;
        },

        /**
         * Set the cart expiry in seconds to local store
         * @param int cartExpirySeconds
         */
        setCartExpiry: function (cartExpirySeconds) {

            var cartExpiry = parseInt(cartExpirySeconds) + FG.Base.getCurrentTimestamp();

            this.cartExpiry = cartExpiry

            return this.db.set('cartExpiry', cartExpiry);
        }
    };
}());
